import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CiViewList } from "react-icons/ci";
import { BsFillPlusSquareFill } from "react-icons/bs";
import { WishlistProps } from "./CompanyList";
import { useInfluencer } from "../../../../Providers/Influencer";
import mixpanel from "mixpanel-browser";
import { Button } from "@/shadcnComponents/ui/button";
import MobileMenuBar from "@/Components/Menubar/MobileMenuBar";

export const Show_Company_List = () => {
  const navigate = useNavigate();
  const influencerState = useInfluencer();
  const [data, setData] = useState<WishlistProps[]>([
    {
      companyName: "",
      companyUrl: "",
    },
  ]);

  useEffect(() => {
    mixpanel.track("Visited View Brand Wishlist Page");
  }, []);

  useEffect(() => {
    async function process() {
      const data2 = await influencerState?.getBrandWishlist();
      if (data2?.success) {
        setData(data2?.data);
      }
    }

    process();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <MobileMenuBar />
      <div className="flex justify-center items-center w-full h-full font-inter">
        <div className="flex flex-col gap-5 w-full h-full p-10">
          <div className="flex flex-col md:flex-row gap-3 items-end justify-between">
            <div className="w-full flex flex-col gap-2 text-white  not-italic font-semibold leading-[normal]">
              <h1 className="text-sm md:text-base">
                Dream Brands? Craft Your Collab Wish List
              </h1>
              <h3 className="text-[#a3a3a3] text-xs md:text-sm font-[400]">
                We can't guarantee every dream collab, but your wishlist fuels
                our search!
              </h3>
            </div>
            <Button
              variant="destructive"
              onClick={() => {
                mixpanel.track("Add More Brands Clicked");
                navigate("/influencer/brands_wishlist");
              }}
              className="text-xs md:text-sm"
            >
              <CiViewList size={20} /> Add More Brands
            </Button>
          </div>
          <div className="flex md:w-[55%] flex-col items-start gap-5 p-5 bg-[color:var(--Natural-900,#212121)] rounded-lg w-full">
            <div className="grid grid-cols-[50px_1fr_1fr] w-full">
              <div className="flex items-center gap-2.5  overflow-hidden rounded text-ellipsis not-italic font-normal leading-[normal] bg-transparent text-sm text-[color:var(--Natural-400,#BDBDBD)]  border-[none]">
                S.No.
              </div>
              <div className="flex items-center gap-2.5  overflow-hidden rounded text-ellipsis not-italic font-normal leading-[normal] bg-transparent text-sm text-[color:var(--Natural-400,#BDBDBD)] px-4 py-3 border-[none]">
                Company Name
              </div>
              <div className="flex items-center gap-2.5  overflow-hidden rounded text-ellipsis not-italic font-normal leading-[normal] bg-transparent text-sm text-[color:var(--Natural-400,#BDBDBD)] px-4 py-3 border-[none]">
                Company Website URL
              </div>
            </div>
            {data?.map((item, i) => (
              <>
                <div
                  key={i}
                  className="grid grid-cols-[50px_1fr_1fr] gap-5 w-full"
                >
                  <div className="flex items-center gap-2.5 bg-transparent overflow-hidden text-[color:var(--Natural-400,#bdbdbd)] rounded border border-[color:var(--Natural-800,#424242)] text-ellipsis text-xs not-italic font-normal leading-[normal] px-4 py-3 border-solid">
                    {i + 1}
                  </div>
                  <div className="flex items-center gap-2.5  bg-transparent overflow-hidden text-[color:var(--Natural-400,#bdbdbd)] rounded border border-[color:var(--Natural-800,#424242)] text-ellipsis text-xs not-italic font-normal leading-[normal] px-2 py-3 border-solid">
                    {item.companyName}
                  </div>
                  <div className="flex items-center gap-2.5  bg-transparent overflow-hidden text-[color:var(--Natural-400,#bdbdbd)] rounded border border-[color:var(--Natural-800,#424242)] text-ellipsis text-xs not-italic font-normal leading-[normal] px-2 py-3 border-solid">
                    {item.companyUrl}
                  </div>
                </div>
              </>
            ))}
          </div>
          <div className="w-full md:w-[55%] justify-end flex">
            <Button
              variant="destructive"
              onClick={() => {
                mixpanel.track("Add Another Brand Clicked");
                navigate("/influencer/brands_wishlist");
              }}
            >
              <BsFillPlusSquareFill size={18} /> Add Another Brand
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
